import { useProjectsQuery } from "@gql/sites-api/graphql";
import { routedClient, LandTechEndpoints } from "react-migration/lib/persistence/apollo";

export function useProjectsList() {
  const { data, ...queryState } = useProjectsQuery({
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
    /**
     * We want to first use the cache for speed, but we also want to want to hit
     * the network in case one of the projects has since been opened resulting
     * in a different order.
     */
    fetchPolicy: "cache-and-network",
  });

  return {
    list: data?.projects ?? [],
    ...queryState,
  };
}
